module.exports = __webpack_public_path__ + "media/badges/savings-discount-badge-157a9801.svg";